import { Component } from '@angular/core';

@Component({
    selector: 'ft-authentication-wrapper',
    templateUrl: './authentication-wrapper.component.html',
    standalone: false
})
export class AuthenticationWrapperComponent {

  constructor() { }
}
